import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Home, Trophy, ArrowLeftRight, Briefcase, Calculator } from 'lucide-react';

export function MobileNav() {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { path: '/', icon: Home, label: 'Terminal' },
    { path: '/rankings', icon: Trophy, label: 'Rankings' },
    { path: '/compare', icon: ArrowLeftRight, label: 'Comparar' },
    { path: '/portfolio', icon: Briefcase, label: 'Carteira' },
    { path: '/juros-compostos', icon: Calculator, label: 'Simular' },
  ];

  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-[8000] bg-[#FAF8F5]/95 dark:bg-[#0A0C10]/95 backdrop-blur-md border-t border-[#E4E0D8] dark:border-[#1F2430] pb-[env(safe-area-inset-bottom)] print:hidden">
      <div className="grid grid-cols-5 divide-x divide-[#E4E0D8] dark:divide-[#1F2430]">
        {menuItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path === '/' && location.pathname.startsWith('/acao/'));
          const Icon = item.icon;

          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className={`relative flex flex-col items-center justify-center py-2.5 min-h-[52px] transition-colors ${
                isActive
                  ? 'bg-white dark:bg-[#11141C] text-[#111315] dark:text-[#F3F4F6]'
                  : 'text-[#5A6065] dark:text-[#8A94A6]'
              }`}
            >
              {isActive && (
                <span className="absolute top-0 left-0 right-0 h-[2px] bg-[#0D7A5F] dark:bg-[#10B981]" />
              )}
              <Icon className={`w-4 h-4 mb-1 ${isActive ? 'text-[#0D7A5F] dark:text-[#10B981]' : ''}`} />
              <span className="font-mono text-[9px] uppercase tracking-wider font-semibold">
                {item.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
